import { useSelector } from 'react-redux';

import { RootState } from '@atom/types/store';
import { UserProfile } from '@atom/types/user';

export const useUserProfile = (): UserProfile => {
  return useSelector((state: RootState) => state.userProfile);
};
